"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _PageContext = _interopRequireDefault(require("../context/PageContext"));
var _WebProfileContext = _interopRequireDefault(require("../context/WebProfileContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useSystemLogo = identifier => {
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const [profileData] = (0, _react.useContext)(_WebProfileContext.default);
  const {
    lang
  } = pageData;
  const [logo, setLogo] = (0, _react.useState)({
    homeLink: "/"
  });
  const {
    logos,
    name
  } = profileData || {};
  (0, _react.useEffect)(() => {
    const logo = logos === null || logos === void 0 ? void 0 : logos.find(logo => logo.identifier === identifier);
    const {
      filename
    } = logo || {};
    let homeLink = "/";
    if (filename) {
      if (lang !== "de") {
        homeLink = "/".concat(lang, "/");
      }
      setLogo({
        alt: name,
        homeLink,
        src: filename
      });
    }
  }, [identifier, lang, logos, name]);
  return logo;
};
var _default = exports.default = useSystemLogo;